@if (this.showNav) {
  <header class="cd-main-header">

    <!-- Section Dropdown-->
    <div class="cd-logo dropdown-master transition-nice" (click)="toggleSectionDropdown()" (clickOutside)="clickOutsideSection()">
      <a class="dropbtn-master dropdown-master">
        <span class="AppSelector pull-left" [ngClass]="{'AppSelectorActive': sectionMenuVisible}">
          @if (navUrl == 'analysis') {
            <p class="app-switcher"><i class="material-icons nav-icon hidden-sm hidden-xs">timeline</i>  Analysis<i class="far fa-chevron-down pad-left" aria-hidden="true"></i></p>
          }
          @if (navUrl == 'data') {
            <p class="app-switcher"><i class="material-icons nav-icon hidden-sm hidden-xs">device_hub</i>  Data<i class="far fa-chevron-down pad-left" aria-hidden="true"></i></p>
          }
          @if (navUrl == 'portfolios') {
            <p class="app-switcher"><i class="material-icons nav-icon hidden-sm hidden-xs">assessment</i>  Portfolio<i class="far fa-chevron-down pad-left" aria-hidden="true"></i></p>
          }
          @if (navUrl == 'folders') {
            <p class="app-switcher"><i class="material-icons nav-icon hidden-sm hidden-xs">folder</i> Folders<i class="far fa-chevron-down pad-left" aria-hidden="true"></i></p>
          }
        </span>
      </a>
      
      @if (sectionMenuVisible) {
        <div class="dropdown-content-master click-menu">
          <a class="b-bottom" data-test-id="AnalysisSection"   [routerLink]="['/analysis']">
            <span>Analysis  <i class="material-icons nav-icon">timeline</i></span>
          </a>
          <a class="b-bottom" data-test-id="DataSection" [routerLink]="['/data']" >
            <span>Data  <i class="material-icons nav-icon">device_hub</i></span>
          </a>
          <a class="b-bottom" data-test-id="PortfolioSection"  [routerLink]="['/portfolios']">
            <span>Portfolio  <i class="material-icons nav-icon">assessment</i></span>
          </a>
          <a class="b-bottom" data-test-id="FolderSection" [routerLink]="['/folders']">
            <span>Folders  <i class="material-icons nav-icon">folder</i></span>
          </a>
        </div>
      }
    </div>

    <div class="company-pickWrap">
      <app-company-picker></app-company-picker>
    </div>

    <div style="float:right;">
      <!-- notifications -->
      <app-notification-center [stamp]='sendNotify'></app-notification-center>
      <!-- cd-search -->
      <!--<a href="#0" class="cd-nav-trigger">Menu<span></span></a>-->

      <!-- Account Dropdown -->
      <div class="cd-nav dropdown-master-2 transition-nice" (click)="toggleAccountDropdown()" (clickOutside)="clickOutsideAccount()">
        <ul class="cd-top-nav dropbtn-master dropdown-master-2">
          <li class="visible-lg visible-md"><div><span class="avatar"><img src="../assets/profile-img.jpg" /></span>  {{ userEmail }}<i class="far fa-chevron-down  pad-left" aria-hidden="true"></i></div></li>
          <li class="hidden-lg hidden-md"><div><span class="avatar"><img src="../assets/profile-img.jpg" /></span>  <i class="far fa-bars user-nav-icon"></i></div></li>
        </ul>
      
        @if (accountMenuVisible) {
          <div class="dropdown-content-master-2 click-menu">
            @if (isAuthAccountSettings) {
              <a class="b-bottom" data-test-id="AccountSection" [routerLink]="['/accountSettings']" ><span>Account Settings  <i class="material-icons nav-icon">account_box</i></span></a>
            }
            @if (isAuthSysAdmin) {
              <a class="b-bottom" data-test-id="AdminSection" [routerLink]="['/sysAdmin']" ><span>Administration  <i class="material-icons nav-icon">settings</i></span></a>
            }
            <a class="b-bottom" data-test-id="TermsSection" [routerLink]="['/termsOfUse']" ><span>Terms Of Use  <i class="fa fa-gavel nav-icon"></i></span></a>
            <a class="b-bottom" data-test-id="HelpSection" (mousedown)="getHelpLink($event);"><span> Help <i class="fa fa-life-ring nav-icon"></i></span></a>
            <a (click)="logout()" data-test-id="LogoutButton"><span>Log Out  <i class="material-icons nav-icon">input</i></span></a>
          </div>
        }
      </div>
    </div>
  </header>
  } <!-- .cd-main-header -->
